<!--  -->
<template>
  <div class>
    <!-- 下拉菜单 -->
    <nav-header @gotoDiv="gotoDiv"></nav-header>
    <!-- 头部 -->
    <div class="headerBox">
      <div class="optBox">
        <van-icon name="wap-nav" class="menuBox" @click="showMenu()" />
        <div class="logoImg">
          <img src="../assets/logo.png" alt="7动" />
        </div>
        <div class="txtBox">
          <div class="leftTxt">
            <img src="../assets/txtLeft.png" alt="7动健康" />
          </div>
          <div class="rightTxt">
            <img src="../assets/txtRight.png" alt="7动健康" />
          </div>
        </div>
        <div class="downBox">
          <div class="downImg" @click="downApp(1)">
            <img src="../assets/downAnd.png" alt="7动安卓版" />
          </div>
          <div class="zzBox"></div>
          <div class="downImg" @click="downApp(2)">
            <img src="../assets/ios.png" alt="7动苹果版" />
          </div>
        </div>
        <div class="txtTips">适用于Apple，Android以及TV端。</div>
      </div>
    </div>
    <!-- 视频部分 -->
    <div class="videoBox" id="video">
      <div class="videoTitleBox">
        <div class="title">教学视频</div>
        <div class="tips">INSTRUCTIONAL VIDEO</div>
        <div class="txt">专业的教练真人示范</div>
      </div>
      <!-- 多视频 -->
      <div v-if="videoLenght > 1">
        <div class="allBtn" @click="show = true">查看全部 ></div>
        <van-dialog v-model="show" @confirm="confirmDown()" title="下载7动，查看更多视频" confirmButtonText="下载" show-cancel-button>
          <img src="../assets/twoPhone.png" alt="7动视频" />
        </van-dialog>
        <div class="listVideo">
          <div class="oneVideo" v-for="(item, index) in videoItem" :key="index" @click="playVideo(item.childplanRemark)">
            <img :src="item.remark" alt="7动视频" />
            <div class="videoTxtBox">
              <div class="title">{{ item.childplanName }}</div>
              <div class="tips">改善体态 骨盆力量</div>
              <div class="time">
                时长：{{ item.palntime }}分
              <!-- <span>13</span>分
                                                            <span>50</span>秒-->
                <span>消耗：</span>
                <span>{{ item.calorie }}千卡</span>
              </div>
              <div class="people">
                参与人数：
                <span>{{ item.palnMsgJson }}</span>人
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 单视频 -->
      <div v-if="videoLenght == 1">
        <div class="videoBoxShow">
          <div class="loadingIcon" v-if="!playOne">
            <img src="../assets/loading.png" alt="7动视频" />
          </div>
          <video id="videoOne" style="width: 100%; height: 100%" :src="playOne" @click="stopVideoPlay"></video>
          <img :src="poster" alt="7动视频" id="videoOneCover" lazy="loaded" style="width: 100%; height: 100%" />
          <div href="javascript:;" id="pauseVideo" style="display: none">
            <img src="../assets/pause.png" alt="7动视频" />
          </div>
          <div id="videoBtnPlay" href="javascript:;" @click="playVideoOne">
            <img src="../assets/play.png" alt="7动视频" />
          </div>
        </div>
      </div>
    </div>
    <!-- 定制计划 -->
    <div class="planBox" id="plan">
      <div class="planTitle">
        <div class="title">定制计划</div>
        <div class="tips">CUSTOM PLAN</div>
      </div>
      <div class="planTips"><span>1分钟</span>解开盆底肌密码</div>
      <div class="planImgBox">
        <div class="leftPlanImg">
          <img src="../assets/plan.png" alt="7动计划" />
        </div>
        <div class="rightPlanImg">
          <img src="../assets/holdPhone.png" alt="7动计划" />
        </div>
      </div>
      <div class="testBtn" @click="toTest()">立即测试</div>
    </div>
    <!-- 粉丝块 -->
    <div class="fansBox" id="fans">
      <div class="fansBg">
        <div class="fansTitleOne">“</div>
        <div class="fansTitleTwo">
          此刻，在
          <span>7动</span>运动
        </div>
        <div class="fansTips">
          每分每秒，都有来自世界的7友与你一同锻炼盆底肌！
        </div>
      </div>
      <div class="fansList">
      <!-- <div class="fansOne" v-for="(item,index) in fansList" :key="index" ref="refContent">
          <div class="headImg"></div>
          <div class="nameBox">
            <div class="name">{{item.name}}</div>
            <div class="tips">{{item.do}} {{item.time}}分钟</div>
          </div>
        </div>
                                                    <div style="clear:both"></div>-->
      <!-- <van-swipe
          id="van-swipe"
          autoplay="2000"
          style="height: 3.5rem;"
          :show-indicators="false"
          vertical
        >
          <van-swipe-item
            style="height: 3.5rem;"
            v-for="(item,index) in arrOne"
            :key="index"
            class="fansOne"
          >
            <div class="headImg">
              <img :src="item.avatar" alt='7动用户' />
            </div>
            <div class="nameBox">
              <div class="name">{{item.nickName}}</div>
              <div class="tips">已经坚持锻炼 {{Math.ceil(item.totalTime/60)}}分钟</div>
            </div>
          </van-swipe-item>
                                                    </van-swipe>-->
        <div id="review_box">
          <ul id="comment1">
            <li v-for="(item, index) in arrOne" :key="index" class="fansOne">
              <div class="headImg">
                <img :src="item.avatar" alt="7动用户" />
              </div>
              <div class="nameBox">
                <div class="name">{{ item.nickName }}</div>
                <div class="tips">
                  已经坚持锻炼 {{ Math.ceil(item.totalTime / 60) }}分钟
                </div>
              </div>
            </li>
          </ul>
          <ul id="comment2"></ul>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <!-- 广告图 -->
    <div class="adBox">
      <img src="../assets/twoPhone.png" alt="7动介绍" />
    </div>
    <!-- 社区交流 -->
  <!-- <div class="communityBox" id="community">
      <div class="planTitle">
        <div class="title">社区交流</div>
        <div class="tips">CUSTOM PLAN</div>
      </div>
      <div class="communityTitle">超70万平台用户进行互动和男女问答</div>
      <div class="floatBox">
        <div
          class="floatOne"
          v-for="(item, index) in communityItem"
          :key="index"
          :id="'commMsgOne' + index"
          @click="showIndex(index)"
        >
          <div class="floatTitle">{{ item.title }}</div>
          <div class="grayIcon"></div>
          <div class="nickName">匿名用户</div>
        </div>
      </div>
                                                </div> -->
    <!-- 视频部分 -->
    <div class="videoBox" id="college">
      <div class="videoTitleBox">
        <div class="title">学院视频</div>
        <div class="tips">COLLEGE VIDEO</div>
      </div>
      <div>
        <van-dialog v-model="show" @confirm="confirmDown()" title="下载7动，查看更多视频" confirmButtonText="下载" show-cancel-button>
          <img src="../assets/twoPhone.png" alt="7动视频" />
        </van-dialog>
        <div class="listVideo" :style="'height:' + moreHeight">
          <div class="oneVideo" v-for="(item, index) in videoCollege" :key="index" @click="playVideo(item.video)">
            <img :src="item.imgUrl" alt="7动视频" />
            <div class="videoTxtBox new">
              <div class="title">{{ item.courseTitle }}</div>
            </div>
            <div id="videoBtnPlay" href="javascript:;">
              <img src="../assets/play.png" alt="7动视频" />
            </div>
          </div>
        </div>
        <div class="moreB" :style="'transform: rotate(' + transNum + 'deg)'" @click="showMoreCollege">
          <img src="../assets/more.png" alt="" />
        </div>
      </div>
      <div class="allBtn" @click="show = true">查看更多 ></div>
    </div>
    <!-- 战略合作 -->
    <div class="partnerBox" id="partner">
      <div class="planTitle">
        <div class="title">战略合作</div>
        <div class="tips">STRATEGIC COOPERATION</div>
      </div>
      <div class="partnerTips">我们的每一步，都能使你变得更优秀</div>
      <div class="partnerImg">
        <img src="../assets/bg3.png" alt="合作伙伴" />
      </div>
    </div>
    <!-- 页脚 -->
    <div class="itemTabBox" id="about">
      <div class="itemTab">
        <div class="tabName">
          <a href="http://pc7dong.com/share/YHXY.html">用户协议</a>
        </div>
        <div class="tabName">
          <a href="http://pc7dong.com/share/YSXY.html">隐私政策</a>
        </div>
      <!-- <div class="tabName">
          <router-link to="/moAbout"> <a href="javascript:;">关于我们</a></router-link>
                                                    </div>-->
      </div>
      <div class="itemTab">
      <!-- <div class="tabName">
          <a href="http://pc7dong.com/share/SQGF.html">社区规范</a>
        </div>
        <div class="tabName">
          <a href="http://pc7dong.com/share/SQGF.html">社区规范</a>
                                                    </div>-->
        <div class="tabName">
          <router-link to="/moAbout">
            <a href="javascript:;">关于我们</a>
          </router-link>
        </div>
        <div class="tabName">
          <router-link to="/moContact">
            <a href="javascript:;">联系我们</a>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 三个图标 -->
    <div class="iconBox">
      <div class="oneIcon">
        <div class="iconImg" @click="showCodeImg(1)">
          <img src="../assets/weibo.png" alt="7动官方微博" />
        </div>
        <div class="iconTxt">7动官方微博</div>
      </div>
      <div class="oneIcon">
        <div class="iconImg" @click="showCodeImg(2)">
          <img src="../assets/weixi.png" alt="7动男版微信群" />
        </div>
        <div class="iconTxt">男神专属</div>
      </div>
      <div class="oneIcon">
        <div class="iconImg" @click="showCodeImg(3)">
          <img src="../assets/weixi.png" alt="7动女版微信群" />
        </div>
        <div class="iconTxt">女生专属</div>
      </div>
    </div>
    <!-- 页脚 -->
    <nav-footer></nav-footer>

    <!-- 视频播放 -->
    <video-player v-show="isPlay" class="video-player vjs-custom-skin videoFloat" ref="videoPlayer" :playsinline="true"
      :options="playerOptions"></video-player>
    <div class="videoBgBox" v-show="isPlay" @click="stopPlay()">
      <div class="closeVideo">关闭</div>
    </div>
    <!-- 全屏查看二维码 -->
    <!-- <van-image-preview v-model="showCode" :images="images" :showIndex="false" @close="hideCodeImg"></van-image-preview> -->
    <van-popup v-model="showImg">
      <img :src="images" alt="7动二维码" />
    </van-popup>
    <van-popup v-model="showDownLoadQRCode" style="background-color: transparent;">
      <img :src="downLoadQRCode" alt="7动二维码" />
    </van-popup>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { ImagePreview } from "vant";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import NavFooter from "@/mobile/common/footer.vue";
import NavHeader from "@/mobile/common/header.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    videoPlayer,
    [ImagePreview.Component.name]: ImagePreview.Component,
    NavFooter,
    NavHeader,
  },
  data() {
    //这里存放数据
    return {
      showDownLoadQRCode: false,
      downLoadQRCode: "",
      showImg: false,
      videoLenght: 0, //视频数据长度
      playOne: [], //第一个视频的地址
      poster: "./static/video.png",
      images: "",
      showCode: false,
      show: false,
      isShowMenu: false,
      btnFlag: false,
      isPlay: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        // poster: "../../static/images/test.jpg", //你的封面地址
        poster: "../assets/logo.png", //你的封面地址

        // width: document.documentElement.clientWidth,
        // notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      arrDiv: 0,
      videoItem: [],
      arrOne: [],
      communityItem: [],
      videoCollege: [],
      moreHeight: "500px",
      transNum: 180,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showMoreCollege() {
      if (this.moreHeight == "500px") {
        this.moreHeight = "auto";
        this.transNum = 0;
      } else {
        this.moreHeight = "500px";
        this.transNum = 180;
      }
    },
    showMenu() {
      var animation = function () {
        let animationClass = "slipShow";
        var ele = document.getElementById("menuBox");
        ele.className = "menuShow " + animationClass;

        // ele = document.getElementById("dialog");
        // ele.className = "msgBox " + animationClass;
      };

      setTimeout(animation, 100);
    },

    toTest() {
      window.location.href =
        "https://pc7dong.com/share/OfficialWebsite/index.html";
    },
    showIndex(index) {
      let ele = document.getElementById("commMsgOne" + index);
      let arr = this.communityItem;
      arr.forEach((item, indexL) => {
        let ele = document.getElementById("commMsgOne" + indexL);
        ele.style.zIndex = Math.floor(Math.random() * (8 - 1) + 1);
        if (indexL != index) {
          ele.style.opacity = 0.5;
        }
      });
      ele.style.zIndex = 9;
      ele.style.opacity = 1;
    },
    // 播放一个视频
    playVideoOne() {
      var video = document.getElementById("videoOne");
      var play = document.getElementById("videoBtnPlay");
      play.style.zIndex = 3;
      video.style.zIndex = 4;
      video.play();
    },
    // 停止播放
    stopVideoPlay() {
      var video = document.getElementById("videoOne");
      var play = document.getElementById("videoBtnPlay");
      play.style.zIndex = 5;
      video.style.zIndex = 4;
      video.pause();
    },
    init() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/back/user/coreTrainingVideoList")
        .then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.code == 0) {
            let arr = res.data.data.list;
            this.videoItem = arr.slice(0, 4);
            this.videoLenght = 1;
            // this.videoLenght = this.videoItem.length;
            if (this.videoLenght == 1) {
              this.playOne = this.videoItem[0].childplanRemark;
              this.poster = this.videoItem[0].remark;
              // this.playVideoOne(this.playOne);
            }
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取粉丝
    getFans() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/back/user/userList")
        .then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.code == 0) {
            let fansArr = res.data.data.list;
            let arr = fansArr;
            this.arrOne = arr.slice(0, fansArr.length / 2);
            // console.log(JSON.stringify(arrOne));
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取社区信息
    getCommunity() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/back/user/consultationList")
        .then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.code == 0) {
            this.communityItem = res.data.data.list;
            // 随机生成位置
            // console.log(this.communityItem.length);
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    gotoDiv(str) {
      document.getElementById(str).scrollIntoView();
      var animation = function () {
        let animationClass = "slipHide";
        var ele = document.getElementById("menuBox");
        ele.className = "menuShow " + animationClass;

        // ele = document.getElementById("dialog");
        // ele.className = "msgBox " + animationClass;
      };

      setTimeout(animation, 100);
    },
    downApp(flag) {
      if (flag == 1) {
        if (window.__wxjs_environment === 'miniprogram') {
          this.downLoadQRCode = require("../assets/androDown_mini.png");
          this.showDownLoadQRCode = true;
        } else {
          window.location.href = "https://pc7dong.com/file/app/android.apk";
        }
      } else {
        if (window.__wxjs_environment === 'miniprogram') {
          this.downLoadQRCode = require("../assets/iosDown_mini.png");
          this.showDownLoadQRCode = true;
        } else {
          window.location.href = "https://itunes.apple.com/cn/app/id1439306852";
        }
      }
    },
    playVideo(url) {
      this.isPlay = true;
      this.playerOptions.sources = [
        {
          src: url,
          type: "video/mp4", // 类型
        },
      ];
    },
    stopPlay() {
      this.isPlay = false;
      this.playerOptions.sources = [""];
    },

    changeClass() {
      let ele = document.getElementById("van-swipe");
      ele.style.height = "10.5rem";
    },
    confirmDown() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        window.location.href = "https://itunes.apple.com/cn/app/id1439306852";
      } else {
        window.location.href = "https://pc7dong.com/file/app/android.apk";
      }
    },
    showCodeImg(num) {
      switch (num) {
        case 1:
          this.images = require("../assets/weibolink.png");
          break;
        case 2:
          this.images = require("../assets/man.png");
          break;
        case 3:
          this.images = require("../assets/gril.png");
          break;
        default:
          break;
      }
      this.showImg = true;
      // this.images.push(url);
      // this.showCode = true;
    },
    hideCodeImg() {
      this.images = [];
    },
    getCollege() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/api/course/selectOfficialCourseList")
        .then((res) => {
          if (res.data.code == 0) {
            this.videoCollege = res.data.data.lists;
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.init();
    this.getFans();
    this.getCommunity();
    this.getCollege();

    // setTimeout(() => {
    //   this.changeClass();
    // }, 1000);
    setTimeout(() => {
      let arr = this.communityItem;
      // let newArr = arr.slice(0,arr.length/2);
      arr.forEach((item, index) => {
        let dom = document.getElementById("commMsgOne" + index);
        let randTop = Math.floor(Math.random() * (90 - 1) + 1);
        let randLeft = Math.floor(Math.random() * (50 - 1) + 1);
        dom.style.top = randTop + "%";
        dom.style.left = randLeft + "%";
      });
    }, 1000);
    // this.$nextTick(() => {
    //   let timer = setTimeout(() => {
    //     if (timer) {
    //       clearTimeout(timer);
    //       this.verScroll();
    //     }
    //   }, 1000);
    // });
    let id = this.$route.query.id;
    var div = document.getElementById(id);
    if (div) {
      setTimeout(function () {
        div.scrollIntoView();
      }, 500);
    }

    //声明的DOM对象为全局
    var ul1 = document.getElementById("comment1");
    var ul2 = document.getElementById("comment2");
    var ulbox = document.getElementById("review_box");

    setTimeout(() => {
      window.onload = roll(50);
    }, 1000);

    function roll(t) {
      ul2.innerHTML = ul1.innerHTML;
      ulbox.scrollTop = 0; // 开始无滚动时设为0
      var timerC = setInterval(rollStart, t); // 设置定时器，参数t用在这为间隔时间（单位毫秒），参数t越小，滚动速度越快
      // 鼠标移入div时暂停滚动
      ulbox.onmouseover = function () {
        clearInterval(timerC);
      };
      // 鼠标移出div后继续滚动
      ulbox.onmouseout = function () {
        timerC = setInterval(rollStart, t);
      };
    }
    // 开始滚动函数
    function rollStart() {
      // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
      if (ulbox.scrollTop >= ul1.scrollHeight) {
        ulbox.scrollTop = 0;
      } else {
        ulbox.scrollTop++;
      }
    }
    // 滚动暂停视频
    let that = this;
    window.addEventListener("scroll", () => {
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 700) {
        that.stopVideoPlay()
      }
    });
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

#review_box {
  // width: 100px;
  height: 250px;
  /* 必须 */
  overflow: hidden;
  /* 必须 */
  margin: auto;
  margin-top: 50px;
  // text-align: center;
}

#review_box ul {
  list-style: none;
}

#review_box ul>li {
  display: flex;
  margin-bottom: 20px;
}

.menuShow {
  position: fixed;
  background: rgba(0, 0, 0, 1);
  z-index: 3;
  width: 100%;
}

.menuList a {
  color: #fff;
}

.menuList ul>li {
  text-align: center;
  width: 100%;
  height: 3rem;
  border-bottom: 1px solid #1f1f1f;
  line-height: 3rem;
  font-size: 0.8rem;
}

.headerBox {
  background-image: url("../assets/bg1.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 20rem;
  width: 100%;
}

.logoImg {
  width: 5rem;
  margin: auto;
  padding-top: 1rem;
}

img {
  width: 100%;
  height: 100%;
}

.menuBox {
  color: #fff;
  font-size: 2rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
}

.optBox {
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
}

.txtBox {
  width: 50%;
  margin: auto;
  margin-top: 2rem;
}

.leftTxt {
  height: 2rem;
  width: 6rem;
}

.rightTxt {
  width: 5rem;
  margin-left: 55%;
}

.downBox {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 75%;
  margin: auto;
  margin-top: 5rem;
}

.downImg {
  width: 42%;
  height: 2.2rem;
}

.zzBox {
  width: 15%;
}

.txtTips {
  color: #fff;
  text-align: center;
  font-size: 0.5rem;
  margin-top: 1rem;
}

.videoFloat {
  position: fixed;
  top: 35%;
  background: #000;
  width: 100%;
  z-index: 999;
}

.listVideo {
  margin-top: 2rem;
  overflow: hidden;
  transition: height 5s;
}

.videoBgBox {
  background: rgba(0, 0, 0, 1);
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 888;
}

.closeVideo {
  color: #c5c5c5;
  font-size: 1rem;
  margin-top: 1rem;
  margin-left: 1rem;
}

.videoTitleBox {
  margin-top: 2rem;
}

.videoTitleBox .title {
  font-size: 1.4rem;
  text-align: center;
}

.videoTitleBox .tips {
  font-size: 0.2rem;
  text-align: center;
  color: #843a3a;
  margin-top: 0.5rem;
}

.videoTitleBox .txt {
  text-align: center;
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #843a3a;
}

.allBtn {
  border: 1px solid #000;
  width: 7rem;
  text-align: center;
  border-radius: 10px;
  height: 1.5rem;
  line-height: 1.6rem;
  margin: auto;
  margin-top: 2rem;
  font-size: 0.8rem;
  color: #000;
}

.oneVideo {
  position: relative;
  // padding: 1rem;
  height: 12rem;
  overflow: hidden;
  width: 90%;
  margin: auto;
  margin-bottom: 1rem;
  border-radius: 5px;
}

.videoTxtBox {
  position: absolute;
  top: 1rem;
  left: 1rem;
  font-size: 1.2rem;
  background: rgba(255, 255, 255, 0.6);
  height: 72%;
  padding: 1rem;
}

.videoTxtBox.new {
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: auto;
  height: 1rem;
  bottom: 0;
  width: 100%;
  color: #fff;
  font-size: 0.8rem;
}

.videoTxtBox .tips,
.time,
.people {
  font-size: 0.5rem;
  color: #555;
}

.videoTxtBox .tips {
  margin-top: 1rem;
}

.videoTxtBox .time {
  margin-top: 1rem;
}

.planBox {
  position: relative;
  height: 25rem;
  overflow: hidden;
}

.planTitle {
  margin-top: 2rem;
}

.planTitle .title {
  font-size: 1.4rem;
  text-align: center;
}

.planTitle .tips {
  font-size: 0.2rem;
  text-align: center;
  color: #843a3a;
  margin-top: 0.5rem;
}

.planTips {
  font-size: 1.3rem;
  text-align: center;
  margin-top: 1.5rem;
}

.planTips span {
  color: red;
  margin-right: 15px;
}

.planImgBox {
  position: relative;
}

.leftPlanImg {
  position: absolute;
  width: 60%;
  z-index: 1;
  top: 3rem;
  left: 1rem;
}

.rightPlanImg {
  position: absolute;
  top: 0;
  width: 100%;
  margin-left: 30%;
}

.testBtn {
  color: #fff;
  background: #000;
  width: 30%;
  text-align: center;
  height: 1.8rem;
  line-height: 2rem;
  border-radius: 5px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 4;
  bottom: 0.5rem;
  left: 35%;
}

.fansBox {
  margin-top: 2rem;
}

.fansBg {
  background-image: url(../assets/bg2.png);
  background-size: cover;
  height: 13rem;
  padding: 1rem 1.5rem;
}

.fansTitleOne {
  font-size: 3rem;
  font-weight: bold;
  width: 2rem;
  height: 2rem;
}

.fansTitleTwo {
  font-size: 1.4rem;
  margin-top: 1rem;
}

.fansTitleTwo span {
  color: red;
}

.fansTips {
  margin-top: 1rem;
  width: 80%;
}

.fansList {
  // margin-top: 2rem;
  overflow: hidden;
}

.fansOne {
  width: 60%;
  margin: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 20%;
  margin-bottom: 1rem;
  height: 2.5rem !important;
}

.fansOne .headImg {
  background: #000;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  overflow: hidden;
}

.nameBox {
  margin-left: 5%;
}

.nameBox .name {
  font-size: 0.8rem;
}

.nameBox .tips {
  font-size: 0.5rem;
  color: #555;
}

.adBox {
  margin-top: 2rem;
}

.communityTitle {
  font-size: 0.8rem;
  color: #636363;
  text-align: center;
  margin-top: 1rem;
}

.floatBox {
  margin-top: 1rem;
  position: relative;
  height: 15rem;
  overflow: hidden;
}

.floatOne {
  position: absolute;
  display: flex;
  border: 1px solid #ccc;
  box-shadow: 1px 1px 1px #ccc;
  font-size: 0.5rem;
  padding: 0.2rem 1rem;
  border-radius: 5px;
  top: 1rem;
  left: 2rem;
  white-space: nowrap;
  background: #fff;
}

.grayIcon {
  background: gray;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  margin-top: 2%;
  margin-right: 0.3rem;
  margin-left: 0.3rem;
}

.communityBtn {
  background: #c9a7a7;
  color: #fff;
  width: 3.5rem;
  height: 3.5rem;
  font-size: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  box-shadow: 0px 5px 5px #ccc;
  margin: auto;
  justify-content: center;
}

.partnerBox {
  margin-top: 3rem;
}

.partnerTips {
  text-align: center;
  margin-top: 1.5rem;
}

.partnerImg {
  width: 90%;
  margin: auto;
  margin-top: 1.5rem;
}

.itemTabBox {
  width: 90%;
  margin: auto;
  margin-top: 4rem;
}

.itemTab {
  display: flex;
  margin-top: 1.5rem;
}

.tabName {
  flex: 1;
  font-size: 0.8rem;
  text-align: center;
}

.tabName a {
  color: #000;
}

.iconBox {
  display: flex;
  width: 90%;
  margin: auto;
  margin-top: 3rem;
}

.oneIcon .iconImg {
  width: 1.5rem;
  height: 1.2rem;
  margin: auto;
}

.oneIcon {
  flex: 1;
  text-align: center;
}

.iconTxt {
  font-size: 0.5rem;
  margin-top: 0.4rem;
}

.footerBox {
  background: #000;
  color: #c3c3c3;
  margin-top: 3rem;
  padding: 0.5rem 1.5rem 1.5rem 1.5rem;
  font-size: 0.8rem;
  text-align: center;
}

.footerTips {
  margin-top: 1rem;
}

.footerTips a {
  color: #c3c3c3;
}

.footerImgBox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footerImgBox .img {
  // background: red;
  border-radius: 10px;
  height: 47px;
  margin-top: 1rem;
  overflow: hidden;
  width: 8rem;
}

#footerImgOne {
  margin-left: 0.5rem;
}

#footerImgOne>>>img {
  width: 100% !important;
  height: 100% !important;
}

.scrollImg {
  // height: 8rem;
}

.my-swipe {
  height: 7.5rem;
  width: 60%;
  margin: auto;
  margin-top: 1rem;
}

.twoImgBox {
  height: 5rem;
  width: 6rem;
  float: left;
}

.van-swipe-item {
  display: flex;
}

.blockBox {
  width: 10%;
}

.twoImgBox span {
  font-size: 0.5rem;
}

.twoImgBox img {
  border-radius: 5px;
}
</style>
<style>
.video-js .vjs-big-play-button {
  width: 20%;
  top: 40%;
  left: 40%;
  border: none;
  background-color: #000;
  border-radius: 0;
}

.van-swipe {
  margin-top: 1rem;
}

.videoBoxShow {
  width: 20rem;
  /* width: 90%; */
  margin: auto;
  margin-top: 1rem;
  border: 2px solid #fff;
  box-shadow: 0 2px 64px 0 rgba(0, 0, 0, 0.12);
  background: #fff;
  position: relative;
  height: 12rem;
}

#videoOne {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: auto;
  top: 0;
  z-index: 1;
}

#videoOneCover {
  position: absolute;
  z-index: 3;
  top: 0;
  background: #fff;
}

#pauseVideo {
  background: rgba(220, 223, 226, 0.75);
  position: absolute;
  top: 40%;
  width: 10%;
  height: 2rem;
  z-index: 3;
  left: 45%;
  border-radius: 50%;
}

#videoBtnPlay {
  background: rgba(185, 185, 185, 0.75);
  position: absolute;
  top: 40%;
  width: 10%;
  height: 2rem;
  z-index: 3;
  left: 45%;
  border-radius: 50%;
  cursor: pointer;
}

#videoBtnPlay>.img {
  background: rgba(232, 232, 232, 0.75);
  cursor: pointer;
}

.moreB {
  width: 1.5rem;
  margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/mobile/index.vue